import React, { useEffect, useState } from 'react';
import './splashscreen.css';
import { getSettings } from '../../../services/settingsService';
import ImageShow from '../../../Uitiles/ImageShow';
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const SplashScreen = ({ onFinish }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(true);
  const [progress, setProgress] = useState(0);
  const [settings, setSettings] = useState({});

  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    getSettings().then(settings => {
      setSettings(settings);
    });
  }, []);

  useEffect(() => {
    // Start fake loading
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          return 100;
        }
        return prev + 2;
      });
    }, 30);

    const timer = setTimeout(() => {
      const hasSeenIntro = localStorage.getItem("hasSeenIntro");
      console.log("hasSeenIntro SplashScreen:", hasSeenIntro);

      // Instead of instant navigate, do overlay transition
      setShowSplash(false);

      setTimeout(() => {
        if (hasSeenIntro === "true") {
          navigate("/mobile/home", { replace: true });
        } else {
          navigate("/mobile/IntroScreens", { replace: true });
        }
      }, 400); // give fade-out time before route change
    }, 3000);

    return () => {
      clearTimeout(timer);
      clearInterval(progressInterval);
    };
  }, [navigate]);

  return (
    <div className={`splash-screen ${!isVisible ? 'fade-out' : ''} ${ showSplash ? "opacity-100 z-50" : "opacity-0 -z-10"}`}>
      <div className="splash-content">
        {/* Animated Background Circles */}
        <div className="splash-bg-circle circle-1"></div>
        <div className="splash-bg-circle circle-2"></div>
        <div className="splash-bg-circle circle-3"></div>

        {/* Logo Container */}
        <div className="splash-logo-container">
          <div className="splash-logo-wrapper">
            {/* Logo with Circular Background */}
            <div className="splash-icon-container">
              {/* Background Circle with Gradient */}
              <div className="splash-circle-bg">
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" style={{ stopColor: '#4f46e5', stopOpacity: 1 }} />
                      <stop offset="100%" style={{ stopColor: '#06b6d4', stopOpacity: 1 }} />
                    </linearGradient>
                  </defs>
                  <circle cx="50" cy="50" r="45" fill="url(#logoGradient)" className="pulse-circle" />
                </svg>
              </div>
              
              {/* Centered Logo */}
              <div className="splash-logo-image">
                {settings.favicon_url ? (
                  <ImageShow 
                    url={settings.favicon_url} 
                    height={80} 
                    width={80} 
                    style={{ 
                      borderRadius: '50%', 
                      objectFit: 'contain',
                      padding: '10px'
                    }} 
                  />
                ) : (
                  <div className="splash-logo-placeholder">
                    <svg viewBox="0 0 24 24" fill="white" width="60" height="60">
                      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z"/>
                    </svg>
                  </div>
                )}
              </div>
            </div>

            {/* App Name */}
            <h1 className="splash-title">
              <img alt="MeddyList - Find Trusted Doctors &amp; Hospitals Near You" src="/static/media/dark_logo.e2be194450463b4a4792.png" />
            </h1>

            {/* Tagline */}
            <p className="splash-tagline">Your Healthcare Companion</p>
          </div>

          {/* Loading Bar */}
          <div className="splash-loading-container">
            <div className="splash-loading-bar">
              <div 
                className="splash-loading-progress" 
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            <p className="splash-loading-text">Loading your experience...</p>
          </div>
        </div>

        {/* Floating Medical Icons */}
        <div className="floating-icons">
          <div className="floating-icon icon-1">💊</div>
          <div className="floating-icon icon-2">🏥</div>
          <div className="floating-icon icon-3">🩺</div>
          <div className="floating-icon icon-4">❤️</div>
          <div className="floating-icon icon-5">⚕️</div>
        </div>

        
      </div>
      {/* Bottom Branding */}
      <div className="splash-footer">
          <p className="splash-footer-text">Powered by Innovation</p>
        </div>
    </div>
  );
};

export default SplashScreen;

